import React, { FC, useEffect } from 'react';
import { useLocation } from 'react-router';
import qs from 'qs';
import { Box } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import Loader from '../../components/Loader/LoaderComponent';
import { useStyles } from '../EventPage/styles';
import { ERROR_FETCHING_RALLY, SET_RALLY_CODE } from '../../store/actions/Rally.actions';

const RallyPage: FC = () => {
    const classes = useStyles();
    const location = useLocation();
    const dispatch = useDispatch();

    useEffect(() => {
        const { code } = qs.parse(location.search, { ignoreQueryPrefix: true });

        if (code) {
            dispatch({ type: SET_RALLY_CODE, payload: code });
        } else {
            dispatch({ type: ERROR_FETCHING_RALLY, payload: 'Something went wrong' });
        }

        setTimeout(() => {
            window.close();
        }, 200);
    }, [dispatch, location.search]);
    return (
        <Box className={classes.loader}>
            <Loader />
        </Box>
    );
};

export default RallyPage;
